import React from 'react'

const Loading = () => {
    return (
        <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            Загрузка...
        </div>
    )
}

export default Loading